import styled from 'styled-components'
import { mq } from '@styles/vars/media-queries.style'
import { textStylesConfig } from '@styles/vars/textStyles.style'
import { getCustomTextStyle } from '@styles/vars/textStyles.style'
import { clamp } from '@styles/utils/conversion.style'
export const PdfFromSideContainer = styled.div`
  color: ${props => props.color};
  padding-bottom: 30px;
  ${mq.tabletL} {
    padding: 50px;
    display:flex;
    flex-flow: column;
  }
`

export const PdfFromContainer = styled.div`
`

export const PdfFromInner = styled.div`
  ${mq.tabletLMax} {
    position: sticky;
    top: 0;
  }
`
export const FormTitle = styled.h3`
  ${getCustomTextStyle(
    textStylesConfig.heading1Serif,
    textStylesConfig.heading2Serif
  )}
  ${clamp('margin-bottom', 20, 40)}
`
export const OpenButton = styled.a`
  margin-top: 15px;
  text-decoration: underline;
  border: unset;
  background: transparent;
  color: currentColor;
  &.hidden {
    display: none;
  }
`